export function shuffle<T>(objects: T[]): T[] {
    const result = objects.slice();
    for (let i = objects.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [result[i], result[j]] = [result[j], result[i]];
    }
    return result;
}
